import { Box } from '@mui/material';
import { StyledRenderedAILogo } from './StyledRenderedAILogo';

export const TransitionPanel = () => (
  <Box sx={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
    <StyledRenderedAILogo />
  </Box>
);
